import { xBaseTheme } from "@guestsupply/XDL/types";

export default { color: "transparent", style: "solid", width: "0px" } as xBaseTheme["focus"];
